var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mt-3 mb-6"},[_c('ReportSectionTopbar',{attrs:{"titleText":"Risk Over Time","infoText":_vm.infoText}}),_c('VueApexCharts',{attrs:{"height":"300","type":"line","options":_vm.options,"series":_vm.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }